import React from 'react';
import { ShoppingCart, CreditCard, Download } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    num: '1',
    icon: ShoppingCart,
    title: 'Comprás',
    desc: 'Ingresás tu correo.'
  }, {
    num: '2',
    icon: CreditCard,
    title: 'Pagás',
    desc: 'Pago 100% seguro en tu moneda local.'
  }, {
    num: '3',
    icon: Download,
    title: 'Descargás',
    desc: 'Recibís el link de acceso inmediato por email.'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-dark border-y border-brand-accent/10" data-id="element-127">
      <div className="max-w-4xl mx-auto" data-id="element-128">
        <h2 className="text-xl md:text-3xl font-black text-center mb-6 text-white uppercase tracking-tight" data-id="element-129">
          🔽 ¿Cómo recibís el material?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 mb-5" data-id="element-130">
          {steps.map((step, i) => {
          const Icon = step.icon;
          return <div key={i} className="bg-brand-card border-2 border-brand-accent/30 rounded-lg p-5 text-center relative shadow-[0_4px_20px_rgba(0,0,0,0.5)] hover:border-brand-accent transition-colors" data-id="element-131">
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-brand-dark w-9 h-9 rounded-full flex items-center justify-center font-black text-base shadow-[0_0_15px_rgba(34,197,94,0.6)]" data-id="element-132">
                  {step.num}
                </div>
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-brand-accent/15 border border-brand-accent/40 mb-3 mt-3" data-id="element-133">
                  <Icon className="w-7 h-7 text-brand-accent" data-id="element-134" />
                </div>
                <h3 className="text-base md:text-lg font-black text-white uppercase mb-1.5" data-id="element-135">
                  {step.title}
                </h3>
                <p className="text-xs md:text-sm text-gray-300 font-bold leading-relaxed" data-id="element-136">
                  {step.desc}
                </p>
              </div>;
        })}
        </div>

        <p className="text-center text-[11px] md:text-xs text-gray-400 font-bold italic" data-id="element-137">
          Si no lo ves en tu bandeja principal, revisá la carpeta de spam.
        </p>
      </div>
    </section>;
}